export function moveGroup(ev: KeyboardEvent): void {
    const target = ev.target;

    if (!(target instanceof HTMLElement)) {
        return;
    }

    const group = target.closest(".settingsGroup");

    if (!(group instanceof HTMLElement)) {
        return;
    }

    let targetElement: Element | null = null;

    if (ev.key === "ArrowDown") {
        targetElement = group.nextElementSibling;
    } else if (ev.key === "ArrowUp") {
        targetElement = group.previousElementSibling;
    }

    if (targetElement instanceof HTMLElement) {
        const firstChild = targetElement.children[0];

        if (firstChild instanceof HTMLElement) {
            firstChild.focus();
        }
    }
}
